import { PhotoStage } from './shared/photoStage.js';

export const RIG = 'forbidden';

export const PROFILE = {
  id: 'hangar',
  family: 'photographic',
  danceability: 0.85,
  requiresTier: 0,
  energyLevel: 0.84,
  bpmMin: 120,
  bpmMax: 150,
  movement: 0.75,
  tonality: 0.30,
  enabled: true
};

// HANGAR: the concrete warehouse (scene b of assets/mainstage; the registry's
// `warehouse` is another piece, both are kept). Cold palettes (white, cyan,
// red), strobe and lasers dominant, tight beams, a lot of haze; CO2 but no
// flames and no confetti; abstract screens (Mixdeck's generators, the
// spectrum) rather than the cover, which shows once per cycle; the DJ and
// crowd shots first. Techno, tech house, minimal. Shared/photoStage.js does
// the rest.
const CONFIG = {
  id: 'hangar', scene: 'b',
  program: { lasers: true, strobe: true, blinders: false, flames: false, co2: true, confetti: null, haze: 0.85, beamSpread: [0.012, 0.045], beamGain: 1.1, programs: ['cross', 'fan', 'sweep', 'ballyhoo'], arms: 0.8, phones: 0.15, bounce: 1 },
  palettes: [[0xe8f4ff, 0x2bffea, 0xff2b2b], [0x2bd8ff, 0xffffff, 0xff3c3c], [0xff2b2b, 0x9ad8ff, 0xffffff]],
  screens: { mix: { content: 0.85, cover: 0.0, title: 0.15 }, exclude: ['nebula'] },
  shots: { prefer: ['dj', 'crowd', 'wide', 'dj', 'crowd'], build: 'dj', drop: ['dj', 'crowd'], calm: ['wide'] },
  intensityCap: 1, protectSky: false
};

export class HangarVisualizer extends PhotoStage {
  constructor(options) { super(CONFIG, options); }
}
